import { ThemeConfig } from "antd";
import colors from "./colors";

export const theme: ThemeConfig = {
  token: {
    colorPrimary: colors.primary,
    colorPrimaryText: colors.header,
    colorBorder: colors.light,
    fontFamily: "Inter",
    colorBgContainerDisabled: colors.primary,
  },
  components: {
    Button: {
      borderRadius: 6,
      controlHeight: 36,
      controlHeightSM: 32,
      borderRadiusSM: 6,
      borderRadiusLG: 6,
      controlHeightLG: 48,
      paddingContentHorizontalLG: 15,
      paddingContentHorizontal: 10,
    },
    Form: {
      colorError: colors.error,
    },
    Input: {
      borderRadius: 6,
      controlHeight: 36,
      borderRadiusSM: 4,
      controlHeightSM: 32,
      borderRadiusLG: 6,
      controlHeightLG: 46,
      colorText: colors.subHeader,
      colorBorder: colors.displayMedium,
      colorTextPlaceholder: colors.extraGray,
      colorError: colors.error,
      colorErrorBorderHover: colors.error,
      colorIcon: colors.bodyText,
      colorBgContainerDisabled: "#f1f1f1",
      colorTextDisabled: colors.subHeader,
    },
    InputNumber: {
      borderRadius: 6,
      controlHeight: 36,
      borderRadiusSM: 4,
      controlHeightSM: 32,
      borderRadiusLG: 6,
      controlHeightLG: 46,
      colorText: colors.subHeader,
      colorBorder: colors.displayMedium,
      colorTextPlaceholder: colors.extraGray,
      colorError: colors.error,
      colorErrorBorderHover: colors.error,
      colorIcon: colors.bodyText,
      colorBgContainerDisabled: "#f1f1f1",
    },
    Select: {
      borderRadius: 6,
      controlHeight: 36,
      borderRadiusSM: 4,
      controlHeightSM: 32,
      borderRadiusLG: 6,
      controlHeightLG: 46,
      colorText: colors.subHeader,
      colorBorder: colors.displayMedium,
      colorTextPlaceholder: colors.extraGray,
      colorError: colors.error,
      colorErrorBorderHover: colors.error,
      colorIcon: colors.bodyText,
      colorErrorBorder: colors.error,
      colorBgContainerDisabled: "#f1f1f1",
    },
    DatePicker: {
      borderRadiusSM: 4,
      controlHeightSM: 32,
      borderRadius: 6,
      controlHeight: 36,
      borderRadiusLG: 6,
      controlHeightLG: 46,
      colorText: colors.subHeader,
      colorBorder: colors.displayMedium,
      colorTextPlaceholder: colors.extraGray,
      colorError: colors.error,
      colorErrorBorderHover: colors.error,
      colorIcon: colors.bodyText,
      colorBgContainerDisabled: "#f1f1f1",
    },
    Checkbox: {
      colorText: colors.displayBody,
      colorBorder: colors.displayMedium,
      colorBgContainerDisabled: "#f1f1f1",
    },
    Badge: {
      lineWidth: 1.5,
    },
    Menu: {
      itemMarginBlock: 4,
      itemMarginInline: 0,
    },
    Table: {
      borderRadiusLG: 0,
      fontSize: 14,
      colorTextHeading: colors.header,
      colorText: colors.bodyText,
      colorBorderSecondary: colors.light, // Table Border Color
      colorBgContainer: "white",
      padding: 12,
    },
    Pagination: {
      itemActiveBg: colors.primary,
      itemSize: 32,
      borderRadius: 4,
      colorText: colors.displayBody,
      fontSize: 13,
    },
  },
};
